import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

export const buildClassFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.CLASS,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const agronomicClass = feature.properties?.agronomic_class;
      return agronomicClass ? [agronomicClass] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const agronomicClass = feature.properties?.agronomic_class;
      if (!agronomicClass) return false;
      return (value as string[]).includes(agronomicClass);
    }
  });
